import React from 'react'
import {REACT_ENV} from "../../../shared/settings";

const TERMS_OF_USE_URL = REACT_ENV === 'development' ? 'https://master.flyxo.jetsm.com/legal/terms-of-use/' : 'https://flyxo.com/legal/terms-of-use/'
const PRIVACY_NOTICE_URL = REACT_ENV === 'development' ? 'https://master.flyxo.jetsm.com/legal/privacy-notice/' : 'https://flyxo.com/legal/privacy-notice/'

export const getLargeFormTexts = lang => {
    if (lang === 'ar') {
        return {
            name: 'الاسم',
            email: 'البريد الإلكتروني',
            password: 'كلمه السر',
            passwordConfirm: 'تأكيد كلمة السر',
            flownBefore: 'هل قمت بالسفر عن طريق طيران الخاص من قبل؟',
            yes: 'نعم',
            no: 'لا',
            passwordRecovery: 'إعادة ضبط كلمة السر',
            backToLogin: 'العودة الى تسجيل الدخول',
            loading: 'جاري التحميل...',
            spentMoney: {
                title: 'كم تنفق على الطيران الخاص في السنة؟',
                first: '-أقل من ٢٥،٠٠٠ دولار',
                second: '- من ٢٥.٠٠٠ الى ٥٠،٠٠٠ دولار',
                third: '-أكثر من ٥٠،٠٠٠ دولار',
            },
            finishRegisration: 'إنهاء التسجيل',
            forgotPassword: 'هل نسيت كلمة المرور؟',
            resetPassword: 'إعادة تعيين كلمة السر',
            resetLinkSended: 'تم ارسال الرابط لتغير كلمة السر الى بريدك الإلكتروني',
            answerErr: 'يرجى الإجابة من فضلك',
            smsCode: 'رمز الرسائل القصيرة',
          emailCode: 'Email Code',
            smsCodeDescription: 'يرجى إدخال رمز التعريف',
            noSmsCode: 'هل استلمت رمزك؟',
            sendAgain: 'ارسال مرة أخرى',
            confirm: 'تأكيد',
            termsErr: 'يجب عليك قبول شروط الاستخدام وسياسة الخصوصية من أجل إنشاء حساب',
            termsErr2: 'يجب عليك قبول شروط الاستخدام وسياسة الخصوصية من أجل إنشاء حساب',
            login: 'سجل الدخول',
            signup: 'حساب جديد',
            or: 'أو',
            errorTexts: {
                name: 'يجب ادخال الاسم بالكامل',
                email: 'يرجى ادخال بريد الكتروني صحيح',
                'email.notvalid': 'يرجى كتابة البريد الإلكتروني',
                'email.exists': 'هذا البريد الإلكتروني موجود',
                password: 'يرجى إدخال كلمة السر',
                rpassword: 'يرجى إعادة ادخال كلمة السر',
                'password.tooshort': 'Must be at least 6 characters',
                'rpassword.nonmatch': 'كلمة المرور غير مطابقة',
                'phone.notvalid': 'رقم الهاتف غير صحيح',
                privacyPolicy: 'يرجى تأكيد موافقتك',
                server_error: 'هناك خطأ ما . حاول مره أخرى',
                already_activated: 'هذا العميل مفعل',
                flownBefore: 'يرجى الإجابة من فضلك',
                'smscode.nonmatch': 'رمز الرسالة غير صحيح',
                survey: 'يرجى الإجابة من فضلك',
            },
            headers: {
                signup: 'إنشاء حساب جديد',
                signupCustom: 'إنشاء حساب جديد',
                login: 'الرجاء تسجيل دخول',
                passwordRecovery: 'إعادة ضبط كلمة السر',
                smscode: 'رمز الرسائل القصيرة',
                flightsExpenses: 'كم تنفق على الطيران الخاص في السنة؟',
                start: '',
            },
            buttons: {
                signup: 'سجل',
                signupCustom: 'سجل',
                login: 'تسجيل دخول',
                passwordRecovery: 'إعادة تعيين كلمة السر',
                smscode: 'تأكيد',
                flightsExpenses: 'إنهاء التسجيل',
                start: 'Activate',
            },
        }
    }
    return {
        name: 'Legal Full Name*',
        email: 'Email*',
        password: 'Password*',
        passwordConfirm: 'Confirm Password*',
        flownBefore: 'I have flown private before',
        yes: 'Yes',
        no: 'No',
        passwordRecovery: 'Password recovery',
        backToLogin: 'Back to Log in',
        loading: 'Loading...',
        spentMoney: {
            title: 'How much do you spend on private aviation per year?',
            first: 'Less than $25,000',
            second: '$25,000-$50,000',
            third: 'More than $50,000',
        },
        finishRegisration: 'Finish registration',
        forgotPassword: 'Forgot password?',
        resetPassword: 'Reset password',
        resetLinkSended: 'Password reset link has been sent to your email.',
        smsCode: 'SMS Code',
        emailCode: 'Email Code',
        smsCodeDescription: 'Please enter your verification code',
        noSmsCode: "Didn't receive one?",
        sendAgain: 'Send it again',
        confirm: 'Confirm',
        termsErr: 'You must accept the Terms of Use in the order to create an account',
        termsErr2: 'You must accept the Privacy Notice in the order to create an account',
        login: 'Log In',
        signup: 'Sign Up',
        or: 'Or',
        errorTexts: {
            country: 'Country is required',
            state: 'State is required',
            How_often_do_you_fly_privately: 'Please answer',
            name: 'Full name is required',
            email: 'Please provide valid email',
            'email.notvalid': 'Please provide valid email',
            'email.exists': 'This email is already exists',
            password: 'Please enter your password',
            rpassword: 'Confirm password is required',
            'password.tooshort': 'Must be at least 6 characters',
            'rpassword.nonmatch': 'Passwords do not match',
            'phone.notvalid': 'Invalid phone number',
            privacyPolicy: 'Please confirm your agree',
            server_error: 'Something went wrong. Please try again',
            already_activated: 'Client is aready activated',
            flownBefore: 'Please answer',
            'smscode.nonmatch': 'Wrong SMS Code',
            survey: 'Please answer',
        },
        headers: {
            signup: 'Please Sign Up',
            signupCustom: 'Join Our Private Jet Marketplace',
            login: 'Please Log In',
            loginRise: 'Please Log In with your JetSmarter account',
            passwordRecovery: 'Password recovery',
            smscode: 'SMS Code',
            flightsExpenses: 'How much do you spend\non private aviation per year?',
            start: '',
        },
        buttons: {
            signup: 'Register',
            signupCustom: 'Register',
            login: 'Login',
            passwordRecovery: 'Reset password',
            smscode: 'Confirm',
            flightsExpenses: 'Next',
            start: 'Activate',
        },
    }
}

export const getLargeAgreements = (lang) =>
    lang === 'ar' ? (
        <>
            أوافق على{' '}
            <a href={TERMS_OF_USE_URL} target="_blank" rel="noopener noreferrer">
              {' '}
                شروط الاستخدام
            </a>
        </>
    ) : (
        <>
          I agree to the <a href={TERMS_OF_USE_URL} target="_blank" rel="noopener noreferrer">
            Terms of Use
        </a>
        </>
    )

export const getLargeAgreements2 = (lang) =>
    lang === 'ar' ? (
        <>
            أوافق على{' '}
            <a href={PRIVACY_NOTICE_URL} target="_blank" rel="noopener noreferrer">
              {' '}
              الشروط الخصوصية
            </a>
        </>
    ) : (
      <>Your personal data will be processed according to our <a
        href={PRIVACY_NOTICE_URL} target="_blank" rel="noopener noreferrer nofollow">Privacy
        Notice</a></>
    )
